<template>
  <div class="flex flex-col gap-5 px-4 w-screen lg:w-176">
    <div class="flex flex-col gap-2 rounded bg-pure-white p-4 lg:p-5">
      <div><BlTextTitle4 text="Comments" /></div>
      <div>
        <BlTextBody2
          text="The comment added to the draft will be visible in the session."
        />
      </div>
    </div>
    <div v-if="fetchLoading" class="h-100 grid place-items-center">
      <div class="blum-loader"></div>
    </div>
    <div
      v-else-if="!sessionComments.length"
      class="flex flex-col gap-4 rounded bg-pure-white p-4 lg:p-5"
    >
      <BlInputText :input="bodyInput" @changed="inputHandler" />
      <div class="pt-2 flex justify-end border-t border-slate-400">
        <BlInputButton
          label="Add comment"
          icon="plus"
          dense
          :disabled="!bodyInput.model || newLoading"
          @clicked="onCreate"
        />
      </div>
    </div>
    <SessionComment
      v-else
      v-for="comment in sessionComments"
      :key="comment.id"
      :comment="comment"
    />
    <div v-if="!fetchLoading && sessionComments.length > 0">
      <div
        v-if="!newOpened"
        class="flex items-center justify-center rounded bg-pure-white p-2 hover:bg-hover-state cursor-pointer"
        @click="openNew"
      >
        <BlTextSubtitle3
          text="Add new comment"
          class="text-light-purple hover:text-dark-purple-200"
        />
      </div>
      <div v-else class="flex flex-col gap-4 rounded bg-pure-white p-4 lg:p-5">
        <BlInputText :input="bodyInput" @changed="inputHandler" />
        <div
          class="pt-2 flex items-center justify-end gap-2 border-t border-slate-400"
        >
          <BlInputButton
            type="outlined"
            dense
            label="Cancel"
            @clicked="newOpened = false"
          />
          <BlInputButton
            label="Add comment"
            icon="plus"
            dense
            :disabled="!bodyInput.model || newLoading"
            @clicked="onCreate"
          />
        </div>
      </div>
    </div>
    <div class="h-6 flex-shrink-0"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SessionComment from "./Item.vue";

import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "SessionDraftComments",
  components: {
    SessionComment,
    BlTextTitle4,
    BlTextSubtitle3,
    BlTextBody2,
    BlInputText,
    BlInputButton
  },
  props: ["sessionId"],
  data() {
    return {
      fetchLoading: false,
      newOpened: false,
      newLoading: false,
      bodyInput: {
        model: "",
        placeholder: "Type your comment",
        textarea: true
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "session", "sessionComments"])
  },
  watch: {
    sessionId(val) {
      if (val) this.fetchSessionComments();
    }
  },
  mounted() {
    if (this.sessionId) this.fetchSessionComments();
  },
  methods: {
    ...mapActions(["getSessionComments", "createSessionComment"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    fetchSessionComments() {
      this.fetchLoading = true;
      const data = {
        id: this.session.id,
        params: "?filter_by=general"
      };
      this.getSessionComments(data).then(() => {
        this.fetchLoading = false;
      });
    },
    openNew() {
      this.bodyInput.model = "";
      this.newOpened = true;
    },
    onCreate() {
      this.newLoading = true;
      const data = {
        id: this.session.id,
        session_comment: {
          user_id: this.currentUser.id,
          body: this.bodyInput.model
        }
      };
      this.createSessionComment(data).then(({ success }) => {
        this.newLoading = false;
        if (!success) return;
        this.newOpened = false;
        this.bodyInput.model = "";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/comment/DraftComments.vue